module.exports = "<div ng2FileDrop\n\n     [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\"\n     (onFileDrop)=\"fileDrop($event)\"\n     [uploader]=\"uploader\"\n     class=\"well my-drop-zone\">\n  <span *ngIf=\"countFileList==0\">Drop your <strong>configuration-file</strong> here.</span>\n  <span *ngIf=\"countFileList>0\">Ready to create a new Global-Project</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/file-upload/file-upload.component.html
// module id = ../../../../../src/app/modules/ui-base/components/file-upload/file-upload.component.html
// module chunks = main